import React from 'react'
import classnames from 'classnames'
import { LinkSoftTableBodyCell } from './bodyCell'
import { LinkSoftTableRowHeaderCell } from './rowHeaderCell'
import { LinkSoftTableColHeaderCell } from './colHeaderCell'
import { getTreeKey } from '@/utils/getTreeCoordinates'

export const TableRow = React.memo(function TableRow (props) {
  const { rowIndex, style, data } = props
  const {
    renderer,
    headerRenderer,
    editor,
    readOnly,
    commentMode,
    columnSizes,
    metadata,
    coordSpecificMetadata,
    dataItems,
    editorActive,
    editorMode,
    currentCol,
    currentRow,
    collapsedRows,
    hiddenRows,
    onCollapseToggled
  } = data
  const tableRowMetadata = metadata[rowIndex]
  const rowHeaderMetadata = tableRowMetadata[0]
  // hide rows under collapsed rows
  if (hiddenRows[rowIndex] || style.height === 0) {
    return null
  }
  const isCurrentRow = rowHeaderMetadata && rowHeaderMetadata.yCoord === currentRow && currentRow > 0
  const Row = 'div'
  return (
    <Row className={classnames('table-row', { 'table-row--current': isCurrentRow })} style={style}>
      {
        columnSizes.map((width, colIndex) => {
          const targetMetadata = tableRowMetadata[colIndex]
          if (!targetMetadata) return null
          const isVisible = targetMetadata.xCoord === colIndex && targetMetadata.yCoord === rowIndex
          if (!isVisible) return null
          const isCurrentCol = targetMetadata.xCoord === currentCol
          const isCurrent = isCurrentCol && isCurrentRow
          const coordMetadata = coordSpecificMetadata && coordSpecificMetadata[getTreeKey(targetMetadata.col, targetMetadata.row)]
          if (!targetMetadata.col && targetMetadata.row) {
            const collapsed = colIndex === 0 && collapsedRows.indexOf(rowHeaderMetadata.row) >= 0
            return (
              <LinkSoftTableRowHeaderCell
                key={colIndex}
                {...targetMetadata}
                {...coordMetadata}
                readOnly={readOnly}
                headerRenderer={headerRenderer}
                value={targetMetadata.value}
                columnSizes={columnSizes}
                isCurrent={isCurrent}
                onCollapseToggled={onCollapseToggled}
                collapsed={collapsed}
              />
            )
          }
          if (targetMetadata.col && !targetMetadata.row) {
            const { className,
              colSpan,
              rowSpan,
              depth,
              value,
              xCoord,
              yCoord } = targetMetadata
            const selectedMetadata = { className,
              colSpan,
              rowSpan,
              depth,
              value,
              xCoord,
              yCoord }
            return (
              <LinkSoftTableColHeaderCell
                key={colIndex}
                {...selectedMetadata}
                {...coordMetadata}
                headerRenderer={headerRenderer}
                isCurrent={isCurrent}
                isCurrentCol={isCurrentCol && targetMetadata.childCount === 0}
                columnSizes={columnSizes}
              />
            )
          }
          const dataItem = targetMetadata.col && targetMetadata.row && dataItems && dataItems.find(x => x.columnTreeCode === targetMetadata.col && x.rowTreeCode === targetMetadata.row)

          return (
            <LinkSoftTableBodyCell
              key={colIndex}
              {...targetMetadata}
              {...dataItem}
              {...coordMetadata}
              commentMode={commentMode}
              value={dataItem ? dataItem.data : null}
              columnSizes={columnSizes}
              isCurrent={isCurrent}
              renderer={renderer}
              editor={editor}
              editorActive={isCurrent && editorActive}
              editorMode={editorMode}
              isCurrentCol={isCurrentCol}
            />
          )
        })
      }
    </Row>
  )
})



// WEBPACK FOOTER //
// ./src/components/report-tables/core/row.js